import clsx from "clsx";
import React, { useMemo } from "react";
import { DropdownField, Label } from "@trainline/depot-web";
import dayjs from "../../../utils/dayjs";
import * as styles from "./TimePicker.module.css";
const TimePicker = ({
  locale,
  id,
  name,
  value,
  options,
  label,
  formatOptionAriaLabel,
  onChange
}) => {
  if (!locale)
    throw new Error("Invalid locale passed to TimePicker");
  const time = dayjs(value);
  const { hour, minutes } = options;
  const hourItems = useMemo(() => {
    return hour.map(({ duration, disabled }) => {
      const formattedHour = duration.format("HH");
      const hourAsDate = dayjs().hour(duration.hours()).minute(0);
      const localisedHour = hourAsDate.locale(locale).format("LT");
      return {
        disabled,
        text: formattedHour,
        value: formattedHour,
        "aria-label": formatOptionAriaLabel(localisedHour)
      };
    });
  }, [formatOptionAriaLabel, hour, locale]);
  const minutesItems = useMemo(() => {
    return minutes.map(({ duration, disabled }) => {
      const formattedMinutes = duration.format("mm");
      return {
        disabled,
        text: formattedMinutes,
        value: formattedMinutes,
        "aria-label": formatOptionAriaLabel(formattedMinutes)
      };
    });
  }, [formatOptionAriaLabel, minutes]);
  const onChangeHour = (event) => {
    const hourString = event.currentTarget.value;
    onChange(event, time.hour(parseInt(hourString, 10)).format("HH:mm"));
  };
  const onChangeMinutes = (event) => {
    const minutesString = event.currentTarget.value;
    onChange(event, time.minute(parseInt(minutesString, 10)).format("HH:mm"));
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx(styles.root)
  }, label && /* @__PURE__ */ React.createElement(Label, {
    htmlFor: id,
    className: styles.label
  }, label), /* @__PURE__ */ React.createElement(DropdownField, {
    testId: "time-picker-hour",
    name: `${name}-hour`,
    id: `${id}-hour`,
    label: label != null ? label : "",
    hideLabel: true,
    items: hourItems,
    value: time.format("HH"),
    onChange: (event) => onChangeHour(event)
  }), /* @__PURE__ */ React.createElement(DropdownField, {
    testId: "time-picker-minutes",
    name,
    nonce: id,
    id,
    label: label != null ? label : "",
    hideLabel: true,
    items: minutesItems,
    value: time.format("mm"),
    onChange: (event) => onChangeMinutes(event)
  }));
};
var TimePicker_default = TimePicker;
export {
  TimePicker_default as default
};
